<script>
    import {default as Pie} from '../charts/Pie.svelte';
    import {labels, colors} from "./kumara-suitability-config";
    import Chip from "./Chip.svelte";

    export let data;
    export let width = 240;
    export let height = 240;

    function process(ds) {
        return ds
            ? [
                {
                    color: colors["1"],
                    name: labels.en["1"],
                    value: ds["propKumaraClass1"]
                },
                {
                    color: colors["2"],
                    name: labels.en["2"],
                    value: ds["propKumaraClass2"]
                },
                {
                    color: colors["3"],
                    name: labels.en["3"],
                    value: ds["propKumaraClass3"]
                },
                {
                    color: colors["4"],
                    name: labels.en["4"],
                    value: ds["propKumaraClass4"]
                }
            ].filter(d => d.value > 0)
            : undefined;
    }

    $: segments = process(data);

    function valueFmt(value) {
        const percentage = (value * 100).toFixed(0);

        if (percentage === '0') {
            return '< 1%';
        }

        if (percentage === '100' && value < 1) {
            return '> 99%';
        }

        return `${(value * 100).toFixed(0)}%`;
    }

    const classes = ['1', '2', '3', '4'];
</script>

{#if segments}
    <div class="kumara-suitability-content">
        <div class="kumara-suitability-text">
            <p>
                The kūmara suitability assessment is based on expert understanding of the impact of soil characteristics and
                climatic conditions on the growth of kūmara. This expert knowledge was refined based on archaeological evidence
                of the presence of pre-1840 Māori kūmara gardens. The NZ Archaeological Association and NIWA are thanked for
                permitting use of the ArchSite database  and the virtual climate station network respectively. This assessment
                is an indication only due to the scale limitations of both the climate and soil information.
            </p>

        </div>
        <div class="pie-outer">
            <div>
                <Pie {segments} {width} {height} {valueFmt} showLabels={false} />
                <div class="suitability-classes">
                    <div>
                        {#each segments as segment}
                            <div class="suitability-class" title={`${segment.name} ${valueFmt(segment.value)}`}>
                                <Chip color={segment.color} />
                                <div class="cls-label">
                                    <b>{segment.name}</b> { valueFmt(segment.value) }
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}


<style>
    .suitability-classes {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .suitability-class {
        display: flex;
        margin-bottom: 0.5em;
    }

    .cls-label {
        flex: 1;
        padding-left: 1em;
    }

    @media (min-width: 440px) {
        .kumara-suitability-content {
            display: flex;
            flex-wrap: wrap;
        }

        .kumara-suitability-content > * {
            flex: 1;
        }

        .pie-outer {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .kumara-suitability-text {
            min-width: 280px;
        }

        .pie-outer > div {
            width: 360px;
            max-width: 100%;
            flex-basis: 360px;
        }
    }
</style>
